import { TripDetailsFormBody } from './TripDetailsFormBody';

export function TripDetailsFormSection() {
  return (
    <div className="flex flex-col gap-y-1">
      <TripDetailsFormBody />
    </div>
  );
}
